// Import pages
import ExpenseList from '../pages/finances/expenses/ExpenseList';
import ExpenseDetail from '../pages/finances/expenses/ExpenseDetail';
import ExpenseForm from '../pages/finances/expenses/ExpenseForm';
import ReimburseExpense from '../pages/finances/expenses/ReimburseExpense';

const expenseRoutes = [
  {
    path: '/finances/expenses',
    element: ExpenseList,
    permission: 'expense.read',
    exact: true
  },
  {
    path: '/finances/expenses/create',
    element: ExpenseForm,
    permission: 'expense.create'
  },
  {
    path: '/finances/expenses/:id',
    element: ExpenseDetail,
    permission: 'expense.read',
    exact: true
  },
  {
    path: '/finances/expenses/:id/edit',
    element: ExpenseForm,
    permission: 'expense.update'
  },
  {
    path: '/finances/expenses/:id/reimburse',
    element: ReimburseExpense,
    permission: 'expense.reimburse'
  }
];

export default expenseRoutes;